import TileLayer from "ol/layer/Tile";
import {XYZ} from "ol/source";
import OSM from "ol/source/OSM";

const createUrl = function (tpl, layerDesc) {
	return tpl
		.replace("{base}", layerDesc.base)
		.replace("{type}", layerDesc.type)
		.replace("{scheme}", layerDesc.scheme)
		.replace("{apiKey}", layerDesc.apiKey);
};

const getHereTileLayer = () => {
	// Plantilla base de URL actualizada (HERE Maps Raster Tile v3)
	const urlTpl = "https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?apikey={apiKey}";
	/* 	const hereLayers = [
		{
			base: "base",
			type: "maptile",
			scheme: "normal.day",
			apiKey: process.env.VUE_APP_HERE_MAP_API_KEY,
		},
	]; */
	/* 	const urlTpl =
		"https://{1-4}.{base}.maps.ls.hereapi.com" +
		"/{type}/2.1/maptile/newest/{scheme}/{z}/{x}/{y}/256/png" +
		"?apiKey={apiKey}"; */
	const layerDesc = {
		base: "base",
		type: "maptile",
		scheme: "normal.day",
		apiKey: process.env.VUE_APP_HERE_MAP_API_KEY,
	};
	const uri = createUrl(urlTpl, layerDesc);
	let hereLayer = new TileLayer({
		visible: false,
		preload: Infinity,
		source: new XYZ({
			url: uri,
			projection: "EPSG:3857",
			opaque: false,
			attributions:
				"Map Tiles &copy; 1987-" +
				new Date().getFullYear() +
				' <a href="https://developer.here.com/" target="_blank">HERE</a>',
			minZoom: 0,
			maxZoom: 18,
			tileSize: 256,
		}),
	});
	hereLayer.setVisible(true);
	return hereLayer;
};
const getGoogleTileLayer = () => {
	let tile = "roadmap";

	switch (tile) {
		case "roadmap":
			tile = "http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}";
			break;
		case "terrain":
			tile = "http://mt0.google.com/vt/lyrs=p&hl=en&x={x}&y={y}&z={z}";
			break;
		case "altered_roadmap":
			tile = "http://mt0.google.com/vt/lyrs=r&hl=en&x={x}&y={y}&z={z}";
			break;
		case "satellite":
			tile = "http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}";
			break;
		case "terrain_only":
			tile = "http://mt0.google.com/vt/lyrs=t&hl=en&x={x}&y={y}&z={z}";
			break;
		case "hybrid":
			tile = "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}";
			break;
		default:
			tile = "http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}";
			break;
	}

	return new TileLayer({
		source: new XYZ({
			url: tile,
			projection: "EPSG:3857",
			attributions:
				"Google; " +
				new Date().getFullYear() +
				" " +
				'<a href="https://developers.google.com/maps/documentation" target="_blank">Google</a>',
			minZoom: 0,
			maxZoom: 18,
			zoom: 12,
		}),
	});
};

export function getTileLayer(mapType) {
	let baseMap = null;
	switch (mapType) {
		case "osm":
			baseMap = new TileLayer({
				source: new OSM({
					attributions:
						'powered by <a href="https://servinformacion.com/" target="_blank">Servinformaci&oacute;n</a>',
					maxZoom: 18,
					minZoom: 8,
					zoom: 14,
				}),
			});
			break;
		case "here":
			baseMap = getHereTileLayer();
			break;
		case "google":
			baseMap = getGoogleTileLayer();
			break;
		default:
			break;
	}
	return baseMap;
}
